import { useFreeMaterialData } from "@/queries/queries/freeMaterialsQueries"
import { useParams } from "react-router"
import FreeMaterialSubject from "../FreeMaterialSubject"

export default function FreeMaterialDetailsSubject() {
  const { courseId, subjectId } = useParams()

  const freeMaterialsQuery = useFreeMaterialData()

  const subject = freeMaterialsQuery.data?.data
    .find((course) => course.id === Number(courseId))
    ?.subjects?.find((subject) => subject.id === Number(subjectId))

  if (!subject) return null

  return <FreeMaterialSubject subject={subject} />
}
